import { NgModule } from '@angular/core';
import { PathCommonModule } from '@widgets/path-common/path-common.module';
import { SiteCommonModule } from '@widgets/site-common/site-common.module';
import { ExtraLoadApprovalNextStepsComponent } from './@shared/extra-load-approval-next-steps/extra-load-approval-next-steps.component';
// tslint:disable-next-line: max-line-length
import { ExtraLoadQpBatchApprovalConfirmationComponent } from './@shared/extra-load-qp-batch-approval-confirmation/extra-load-qp-batch-approval-confirmation.component';
// tslint:disable-next-line: max-line-length
import { ExtraLoadQpBatchApprovalFormComponent } from './@shared/extra-load-qp-batch-approval-form/extra-load-qp-batch-approval-form.component';

// tslint:disable-next-line: max-line-length
import { ExtraLoadQpBatchApprovalWarningComponent } from './@shared/extra-load-qp-batch-approval-warning/extra-load-qp-batch-approval-warning.component';
import { ExtraLoadRejectComponent } from './@shared/extra-load-reject/extra-load-reject.component';
import { ApproveExtraLoadComponent } from './approve-extra-load.component';
import { BatchSummaryComponent } from './batch-summary/batch-summary.component';
import { ExtraLoadSummaryComponent } from './extra-load-summary/extra-load-summary.component';
import { ExtraLoadApprovalGrantComponent } from './@shared/extra-load-approval-grant/extra-load-approval-grant.component';

@NgModule({
  declarations: [
    ApproveExtraLoadComponent,
    BatchSummaryComponent,
    ExtraLoadSummaryComponent,
    ExtraLoadRejectComponent,
    ExtraLoadApprovalNextStepsComponent,
    ExtraLoadQpBatchApprovalConfirmationComponent,
    ExtraLoadQpBatchApprovalFormComponent,
    ExtraLoadQpBatchApprovalWarningComponent,
    ExtraLoadApprovalGrantComponent
  ],
  exports: [ApproveExtraLoadComponent],
  imports: [SiteCommonModule, PathCommonModule]
})
export class ApproveExtraLoadModule {}
